import { Component, Input, OnInit } from '@angular/core';
import { DetalhesInvestimento } from '../../../model/detalhes-investimento';

@Component({
  selector: 'card-lista-investimento',
  templateUrl: './card-lista-investimento.component.html',
  styleUrls: ['./card-lista-investimento.component.css']
})
export class CardListaInvestimentoComponent implements OnInit {

  @Input() listaInvestimento: DetalhesInvestimento[] = [];
  colunasTabelaDocumentos = ['dataInvestimento', 'valorInvestido'];

  constructor() { }

  ngOnInit() {
  }

}
